export const ERROR_LOGIN_MESSAGES = {
  VALIDATION: {
    USER_REQUIRED: 'El Usuario es requerido',
    USER_INVALID: 'Ingresa un Usuario válido',
    PASSWORD_REQUIRED: 'La contraseña es requerida',
    PASSWORD_MIN_LENGTH: (length: number) =>
      `La contraseña debe tener al menos ${length} caracteres`,
    REQUIRED: 'Este campo es obligatorio',
  },
  ERROR: {
    AUTHENTICATION_MESSAGE: 'Error en la autenticación',
    UNAUTHORIZED: {
      TITLE: 'Credenciales incorrectas',
      SUBTITLE: 'Verifica usuario y contraseña.',
    },
    GENERIC: {
      TITLE: 'Error de conexión con el servidor',
      SUBTITLE: 'Intenta nuevamente',
    },
  },
} as const;
